import { Box, Typography } from "@mui/material";
import ManualChatPanel from "./ManualChatPanel";
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

interface AiChatSideBarProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  pageName?: string;
}

function AiChatSideBar({ open, setOpen, pageName }: AiChatSideBarProps) {
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  if (!open) return null;
  return (
    <Box
      sx={{
        minWidth: isSmartPhone ? "calc(100% + 30px)" : "300px",
        maxWidth: isSmartPhone ? undefined : "300px",
        marginTop: isSmartPhone ? "80px" : undefined,
        height: "calc(100vh - 80px)",
        borderLeft: isSmartPhone ? undefined : "silver 0.2px solid",
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.paper",
        position: isSmartPhone ? undefined : "absolute",
        right: isSmartPhone ? undefined : 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1,
          py: 0.5,
          minHeight: "40px",
        }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
          AIサポート
        </Typography>
      </Box>
      <Box sx={{ flex: 1, overflow: "hidden", minHeight: 0 }}>
        <ManualChatPanel pageName={pageName} />
      </Box>
    </Box>
  );
}

export default AiChatSideBar;
